import React, { useState, useEffect } from 'react';
import './ProgrammeConference.css';
import { programmeService } from '../services/programmeService';
import { supabase } from '../supabaseClient';

const ProgrammeConference = ({ edition: customEdition }) => {
  const [programmeData, setProgrammeData] = useState({
    pdfUrl: '',
    buttonText: 'Voir le Programme',
    isVisible: true,
    flashInfoPdfUrl: '',
    flashInfoButtonText: 'Flash Info',
    flashInfoIsVisible: true
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadProgrammeData();
  }, [customEdition]);

  const loadProgrammeData = async () => {
    try {
      setLoading(true);
      
      let editionYear = customEdition;
      if (!editionYear) {
        // Get active edition first
        const { data: activeEdition, error: editionError } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', true)
          .single();
        editionYear = activeEdition?.year || '2025';
      }

      const data = await programmeService.getProgrammeData(editionYear);
      
      if (data) {
        setProgrammeData(data);
      } else {
        // Use default data if none found
        setProgrammeData({
          pdfUrl: '',
          buttonText: 'Voir le Programme',
          isVisible: false,
          flashInfoPdfUrl: '',
          flashInfoButtonText: 'Flash Info',
          flashInfoIsVisible: false
        });
      }
      setError(null);
    } catch (error) {
      setError('Failed to load programme data');
      // Set default to not visible if error
      setProgrammeData({
        pdfUrl: '',
        buttonText: 'Voir le Programme',
        isVisible: false,
        flashInfoPdfUrl: '',
        flashInfoButtonText: 'Flash Info',
        flashInfoIsVisible: false
      });
    } finally {
      setLoading(false);
    }
  };

  // Handle PDF view in new tab
  const handleViewPDF = () => {
    if (programmeData.pdfUrl) {
      window.open(programmeData.pdfUrl, '_blank');
    } else {
      alert('Aucun fichier programme n\'est disponible pour le moment.');
    }
  };

  // Handle Flash Info PDF view in new tab
  const handleViewFlashInfo = () => {
    if (programmeData.flashInfoPdfUrl) {
      window.open(programmeData.flashInfoPdfUrl, '_blank');
    } else {
      alert('Aucun fichier flash info n\'est disponible pour le moment.');
    }
  };

  // Don't render if loading
  if (loading) {
    return null;
  }

  // Check if any button should be visible
  const showProgramme = programmeData.isVisible && programmeData.pdfUrl;
  const showFlashInfo = programmeData.flashInfoIsVisible && programmeData.flashInfoPdfUrl;

  if (!showProgramme && !showFlashInfo) {
    return null;
  }

  return (
    <div className="programme-buttons-container">
      {showProgramme && (
        <div className="programme-button-container">
          <button 
            className="programme-ticket-button" 
            onClick={handleViewPDF}
            title="Voir le programme"
          
          >
            <i className="fa-light fa-ticket"></i>
            <span>{programmeData.buttonText}</span>
          </button>
        </div>
      )}
      
      {showFlashInfo && (
        <div className="flash-info-button-container">
          <button 
            className="flash-info-button" 
            onClick={handleViewFlashInfo}
            title="Voir le flash info"
          >
            <i className="fa-light fa-info-circle"></i>
            <span>{programmeData.flashInfoButtonText}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ProgrammeConference;

